import React, { PureComponent } from 'react';

import FieldDefault from './field-default';
import ColorPicker from './color-picker';

import IconEdit from '../icons/icon-edit';
import IconPlus from '../icons/icon-plus';

export default class CustomFieldDropdownOption extends PureComponent {
    static defaultProps = {
        value: '',
        color: '#626262'
    }

    state = {
        color: this.props.color,
        value: this.props.value
    }

    handleValueChange = value => {
        this.setState({ value });

        this.update(value, this.state.color);
    }

    handleColorChange = color => {
        this.setState({ color });

        this.update(this.state.value, color);
    }

    handleKeyDown = event => {
        const { which } = event;

        if (which === 13) {
            this.props.onReturn && this.props.onReturn();
        }
    }

    update(value, color) {
        this.props.onChange && this.props.onChange(this.props.id, { value, color });
    }

    render() {
        return (
            <div className="custom-field-dropdown-option">
                <div className="custom-field-dropdown-option-field" style={{ color: this.state.color }}>
                    <FieldDefault
                        addonTransparent={true}
                        placeholder="Option name"
                        value={this.state.value}
                        onChange={this.handleValueChange}
                        onKeyDown={this.handleKeyDown}
                        autoFocus={this.props.autoFocus}
                        addon={(
                            <ColorPicker
                                compact={true}
                                selected={this.state.color}
                                onSelect={this.handleColorChange}
                            >
                                {
                                    this.props.color ? (
                                        <span className="color-select-trigger">
                                            <IconEdit />

                                            Edit color
                                        </span>
                                    ) : (
                                        <span className="color-select-trigger">
                                            <IconPlus />

                                            Add color
                                        </span>
                                    )
                                }
                            </ColorPicker>
                        )}
                    />
                </div>
            </div>
        );
    }
}
